import { Component, OnInit } from '@angular/core';
import { EnterpriseService } from '../enterprise.service';
import { MetaService } from 'src/app/shared/services/meta.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CanonicalService } from 'src/app/shared/services/canonical.service';
import { CommonModule } from '@angular/common';
import { ToHtmlPipe } from 'src/app/shared/utilities/to-htmlpipe/to-html.pipe';

@Component({
  selector: 'app-enterprise-other-features',
  templateUrl: './other-features.component.html',
  imports: [CommonModule, ToHtmlPipe],
})
export class EnterpriseOtherFeaturesComponent implements OnInit {
  otherFeaturesData:any;
  constructor(
    private enterpriseService: EnterpriseService,
    private meta: MetaService,
    private route: ActivatedRoute,
    private canonical: CanonicalService,
    private router: Router
  ) {
    this.getUrl = this.router.url;
  }

  getUrl: any;
  metaBody = {
    title: '',
    description: '',
    url: '',
    image: '',
    type: '',
  };
  ngOnInit(): void {
    this.enterpriseService.scaleupFeaturePanel2$.subscribe(data => {
      if (data != null) {
        this.otherFeaturesData = data;
      }
    });
  }
}
